import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ApplicationContext } from "@context/ApplicationContext";
import "./style.scss";

const PoweredBy = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const location = useLocation();
    
    const pageTextColor = useMemo(() => {
        if (location.pathname === "/welcome") {
            return whiteLabel?.subscriber_group?.subscriber_group_welcome_page?.page_text_color;
        } if (location.pathname === "/lets-get-started") {
            return whiteLabel?.subscriber_group?.subscriber_group_get_started?.page_text_color;
        }
        return null;
    }, [location.pathname, whiteLabel]);

    const textStyle = pageTextColor ? { color: pageTextColor } : {};

    return (
        <a
            href="https://www.chooviegroup.com"
            className="powered__link"
            target="_blank"
            rel="noreferrer"
        >
            <span className="powered__text" style={textStyle}>powered by</span>
            <span className="powered__text powered__text--large" style={textStyle}>CHOOVIE</span>
            <span className="powered__text" style={textStyle}>GROUP</span>
        </a>
    );
};

export default PoweredBy;
